import api from './api';

const authService = {
  async login(username, password) {
    return api.post('/auth/login', { username, password });
  },

  async me() {
    return api.get('/auth/me');
  },

  async changePassword(currentPassword, newPassword) {
    return api.patch('/auth/change-password', {
      currentPassword,
      newPassword,
    });
  },

  logout() {
    localStorage.removeItem('ejt_token');
    localStorage.removeItem('ejt_user');
    window.location.href = '/login';
  },

  getUser() {
    try {
      return JSON.parse(localStorage.getItem('ejt_user') || '{}');
    } catch {
      return {};
    }
  },

  getToken() {
    return localStorage.getItem('ejt_token');
  },

  isAuthenticated() {
    return !!localStorage.getItem('ejt_token');
  },
};

export default authService;